import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { helpers } from '../helpers';
import { parallaxAnim, summaryAnim, appearAnim } from '../animations';
import loadVideos from '../videos';
import Splide from '@splidejs/splide';

gsap.registerPlugin(ScrollTrigger);

const heroAnim = () => {
    const frame = document.querySelector('.hero__frame');
    const frameNest = document.querySelector('.hero__frame img');
    const frameImg = document.querySelector('.hero__frame-img img');

    function loaded() {
        frameImg?.classList.add('loaded');
    }

    if (frameNest?.complete) {
        loaded();
    } else {
        frameNest?.addEventListener('load', loaded);
    }

    ScrollTrigger.create({
        trigger: '.hero',
        start: 'top top+=56',
        onEnter: () => {
            frame?.classList.add('hero__frame--rotate');
        },
        onLeaveBack: () => {
            frame?.classList.remove('hero__frame--rotate');
        },
    });
};

const iphoneSlider = () => {
    const plates = new Splide('.iphone-slider__plates', {
        type: 'loop',
        perMove: 1,
        perPage: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 600,
        arrows: helpers.isMobile() ? false : true,
        pagination: false,
        autoplay: true,
        interval: 5000,
        padding: {
            left: helpers.isPhone() ? '20%' : '32%',
            right: helpers.isPhone() ? '20%' : '32%',
        },
        updateOnMove: true,
        easing: 'ease-in-out',
    });

    const tables = new Splide('.iphone-slider__tables', {
        type: 'loop',
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 600,
        arrows: false,
        pagination: false,
        easing: 'ease-in-out',
    });

    plates.sync(tables);

    plates.mount();
    tables.mount();
};

const gridAnim = () => {
    const lines = document.querySelector('.photo-grid__lines');

    const handleClasses = () => {
        lines.classList.add('photo-grid__lines--active');

        setTimeout(() => {
            lines.classList.remove('photo-grid__lines--active');
        }, 3000);
    };

    handleClasses();

    setInterval(() => {
        handleClasses();
    }, 4000);
};

const promoAnim = () => {
    const headings = document.querySelectorAll('.fancy');

    headings.forEach((heading) => {
        const letters = heading.textContent.split('');

        const content = letters.map((val, i) => {
            const delay = Math.floor(Math.random() * 500 + 1);

            return '<span style="transition-delay: ' + delay + 'ms">' + val + '</span>';
        });

        heading.innerHTML = '';

        for (var i = 0; i < content.length; i++) {
            heading.innerHTML += content[i];
        }

        ScrollTrigger.create({
            trigger: heading,
            start: 'top bottom+=200',
            onEnter: () => {
                heading.classList.add('fancy--anim');
            },
        });
    });
};

const skewAnim = () => {
    const skewNest = document.querySelector('.gallery-skew');
    const skewImg = document.querySelectorAll('.gallery-skew__img');

    skewImg.forEach((img) => {
        ScrollTrigger.create({
            trigger: skewNest,
            start: 'center bottom',
            onEnter: () => {
                img.classList.add('gallery-skew__img--active');
            },
            onLeaveBack: () => {
                img.classList.remove('gallery-skew__img--active');
            },
        });
    });
};

(function () {
    loadVideos();
    heroAnim();
    iphoneSlider();
    gridAnim();
    promoAnim();
    skewAnim();
    parallaxAnim();
})();

window.addEventListener('load', () => {
    summaryAnim();
    appearAnim();
});
